import CupsListTablePaginator from './CupsListTablePaginator';

export default CupsListTablePaginator;
